import React, { useState } from 'react';
// General Utils
import { theme } from 'theme';

// Material Core and Icons
import { styled } from '@material-ui/core/styles';
import { Stack, Typography, useTheme, Grid, Button } from '@mui/material';
import { RedLinkButton, getTotalProductNum } from 'pages/ticketV2/common';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';

import {
  ModeEditOutlineOutlined,
  MenuBookTwoTone,
  Check,
} from '@mui/icons-material';
import { useTicketsStore } from 'pages/ticketV2/store/ticketsStore';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';

const Card = styled('div')(({ isSmDown }) => ({
  padding: isSmDown ? 16 : 20,
  width: '100%',
  minHeight: 100,
  marginBottom: 25,
  backgroundColor: theme.colors.primary.white,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  position: 'relative',
}));

const MerchCard = ({
  isSmDown,
  isMdDown,
  isOperator,
  locale,
  loggedUser,
  merch,
}) => {
  const { merchInCart } = useTicketsStore();
  const theme = useTheme();
  const intl = useIntl();
  const i18nCommon = translations.TicketsV2(intl).Common;
  const i18nRecap = translations.TicketsV2(intl).Recap;
  const [isEditMode, setIsEditMode] = useState(false);
  const [currenMerch, setCurrentMerch] = useState([]);

  const onUpdateQuantity = (newQuantity) => {
    const updateCurrentMerch = currenMerch.find((m) => m.id === merch.id);
    const updateMerch = [
      ...currenMerch.filter((m) => m.id !== updateCurrentMerch.id),
      {
        ...updateCurrentMerch,
        quantity: updateCurrentMerch.quantity + newQuantity,
      },
    ];
    setCurrentMerch(updateMerch);
  };

  const onEdit = () => {
    setCurrentMerch(merchInCart);
    setIsEditMode(true);
  };
  const onSave = () => {
    useTicketsStore.setState({
      merchInCart: currenMerch,
    });
    setIsEditMode(false);
  };

  const UpdateMerchInput = () => (
    <Stack direction={'row'}>
      <Button
        disabled={currenMerch.find((m) => m.id === merch.id)?.quantity === 0}
        variant="contained"
        sx={{
          width: '45px',
          height: '45px',
          padding: 0,
          minWidth: 0,
        }}
        onClick={() => onUpdateQuantity(-1)}
      >
        <RemoveIcon fontSize="20px" />
      </Button>
      <Stack
        alignItems={'center'}
        justifyContent={'center'}
        sx={{ width: '40px' }}
      >
        <Typography variant="body2-bold" fontFamily={'Suisse-Intl'}>
          {getTotalProductNum(currenMerch)}
        </Typography>
      </Stack>
      <Button
        disabled={currenMerch.find((m) => m.id === merch.id)?.quantity === 99}
        variant="contained"
        sx={{
          width: '45px',
          height: '45px',
          padding: 0,
          minWidth: 0,
        }}
        onClick={() => onUpdateQuantity(+1)}
      >
        <AddIcon fontSize="20px" />
      </Button>
    </Stack>
  );

  const CartMerchInfo = () => (
    <Typography
      variant="link2"
      color="grey.800"
      sx={{ display: 'flex', alignItems: 'center' }}
    >
      <MenuBookTwoTone
        sx={{
          color: theme.palette.grey[800],
          mr: 0.6,
        }}
        fontSize="20px"
      />
      <span style={{ fontWeight: 600, marginRight: '5px' }}>
        {getTotalProductNum(merchInCart)}x
      </span>
      {merchInCart[0]?.description_map?.[locale] ||
        merchInCart[0]?.description_map?.it ||
        merchInCart[0]?.description ||
        ''}
    </Typography>
  );

  const TicketActions = () => (
    <Stack
      direction={'row'}
      alignItems={'center'}
      justifyContent={isMdDown ? 'space-between' : 'flex-end'}
      gap={'30px'}
    >
      <RedLinkButton
        onClick={() => (isEditMode ? onSave() : onEdit())}
        msg={i18nCommon[isEditMode ? 'updateQuantity' : 'editQuantity']}
        icon={
          isEditMode ? (
            <Check color="primary" />
          ) : (
            <ModeEditOutlineOutlined color="primary" />
          )
        }
      />
    </Stack>
  );

  return (
    <Card isSmDown={isSmDown}>
      <Grid container>
        <Grid container item xs={12} alignItems="center" sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <div
              style={{
                backgroundColor: theme.palette.grey[200],
                color: 'black',
                borderRadius: '25px',
                width: 'fit-content',
                display: 'flex',
                padding: '5px 10px',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <Typography
                variant="xs-bold"
                textAlign="center"
                fontFamily={'Suisse-Intl'}
              >
                {i18nCommon.accountOwner}
              </Typography>
            </div>
          </Grid>
          {!isMdDown && (
            <Grid item xs={6}>
              <TicketActions />
            </Grid>
          )}
        </Grid>

        <Grid item xs={12} md={5}>
          <Typography
            variant="m-bold"
            paragraph
            marginBottom={1.5}
            fontFamily={'Suisse-Intl'}
          >{`${loggedUser.givenName} ${loggedUser.familyName} `}</Typography>

          <Typography
            paragraph
            variant="link2"
            marginBottom={'16px !important'}
          >
            {isOperator ? i18nCommon.operator : i18nCommon.generalPublic}
          </Typography>
        </Grid>

        <Grid item xs={12} md={7}>
          <Grid container item marginBottom={'20px'}>
            <Grid item xs={12} md={4}>
              <Typography variant="link2" fontWeight="bold">
                {i18nRecap.otherPurchases}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} alignItems="center">
              {isEditMode ? <UpdateMerchInput /> : <CartMerchInfo />}
            </Grid>
          </Grid>
        </Grid>

        {isMdDown && (
          <Grid item xs={12} marginTop={2}>
            <TicketActions />
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default MerchCard;
